// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Xy-mV","validationTips":"StatementDescriptor_validationTips__NkcFl"};